<template>
  <div class="slt-wrp">
    <div class="bg-mask" @click="onConfirm" v-show="isShowCheckIn"></div>
    <div class="slt-tar" @click="onShowPanel">
      <div class="icon-peoples"></div>
      <div class="peoples-box">
        <p>
          <span>{{$t('hotel.PREFIX_ADULTS')}}{{adults}}{{+adults > 1 ? $t('hotel.SUFFIX_ADULTS') : $t('hotel.SUFFIX_ADULT')}}<!-- 成人 --></span>
          <span>{{$t('hotel.PREFIX_CHILDREN')}}{{children}}{{+children > 1 ? $t('hotel.SUFFIX_CHILDREN') : $t('hotel.SUFFIX_CHILD')}}<!-- 儿童 --></span>
          <span>{{rooms}}{{$t('hotel.Many_Rooms')}}<!-- 间 --></span>
        </p>
        <!--<p>-->
          <!--<span style="color: #666">{{rooms}}{{$t('hotel.Many_Rooms')}}&lt;!&ndash; 间 &ndash;&gt;</span>-->
        <!--</p>-->
      </div>
    </div>

    <div class="oper-wrp" v-if="isShowCheckIn">
      <div class="person-ctrl">
        <div class="clearfix ctrl-row">
          <div class="ct-left">{{$t('hotel.guestRoom')}}<!-- 客房 --></div>
          <div class="ct-right">
            <bg-count v-model="rooms" :max="maxRoom" :min="minRoom"></bg-count>
          </div>
        </div>
        <div class="clearfix ctrl-row">
          <div class="ct-left">{{$t('hotel.SUFFIX_ADULTS')}}(每间)<!-- 成人 --></div>
          <div class="ct-right">
            <bg-count v-model="adults" :max="maxAdults"></bg-count>
          </div>
        </div>
        <div class="ctrl-row">
          <div class="ct-left">{{$t('hotel.SUFFIX_CHILDREN')}}(每间)<!-- 儿童 --></div>
          <div class="ct-right">
            <bg-count v-model="children" :max="maxChildren"></bg-count>
          </div>
        </div>
      </div>

      <div class="bottom-ctrl">
        <div v-if="+children > 0" style="font-size: 0;">
          <p class="child-tt">{{$t('hotel.CHILD_AGE')}}<!-- 儿童年龄 -->：</p>
          <div>
            <template v-for="i in children">
              <age-ctrl :default-age="ages[i - 1] ? ages[i - 1] : 0" :key="i" @on-age="onGetAge(i, arguments)"></age-ctrl>
            </template>
          </div>
        </div>

        <div class="bt-row">
          <!--<bg-button type="primary" is-blank class="cancel-btn" font-weight="bold" @click.native="isShowCheckIn = false">{{$t('hotel.CANCEL')}}&lt;!&ndash; 取消 &ndash;&gt;</bg-button>-->
          <button type="primary" class="cancel-confirm" font-weight="bold" @click="onConfirm">{{$t('hotel.OK')}}<!-- 确定 --></button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import BgButton from '../BgButton/BgButton';
  import BgCount from '../BgCount/BgCount';
  import AgeCtrl from './age-ctrl';
  import {mapGetters} from 'vuex';

  export default {
    name: 'check-in-number',
    components: {
      BgButton,
      BgCount,
      AgeCtrl,
    },
    props: {
      // rooms: {
      //   type: Number | String,
      //   default: 1,
      // },
    },
    data(){
      return {
        isShowCheckIn: false,
        maxAdults: 10,
        maxChildren: 3,
        maxRoom: 10,
        minRoom: 1,
        adults: 1,
        children: 0,
        rooms: 1,
        ages: [],
      };
    },
    computed: {
      ...mapGetters({
        getAdults: 'getAdults',
        getChildren: 'getChildren',
        getAges: 'getAges',
        getRooms: 'getRooms',
      }),
    },
    watch: {
      rooms(cur){
        this.maxAdults = cur * 10;
        this.maxChildren = cur * 3;

        if(this.children > this.maxChildren){
          this.children = this.maxChildren;
          this.ages = this.ages.splice(0, this.maxChildren);
        }

        if(this.adults > this.maxAdults){
          this.adults = this.maxAdults;
        }
      },

      children(cur){
        if(cur > this.ages.length){
          this.ages.push(0);
        }else{
          this.ages.pop();
        }
      },
    },
    mounted(){
      this.maxAdults = this.rooms * 10;
      this.maxChildren = this.rooms * 3;
      this.children = this.getChildren;
      this.adults = this.getAdults;
      this.rooms = this.getRooms;

      setTimeout(() => {
        this.ages = this.getAges.split(',');
      }, 100);
    },
    methods: {
      onShowPanel(){
        this.isShowCheckIn = !this.isShowCheckIn;
      },

      onConfirm(){
        const result = {
          adults: this.adults,
          children: this.children,
          ages: this.ages,
          rooms: this.rooms
        };

        this.isShowCheckIn = false;
        this.$emit('on-condition', result);
      },

      onGetAge(idx, args){
        this.$set(this.ages, idx - 1, args[0].toString());
      },
    },
  }
</script>

<style lang="scss" scoped>
  .slt-wrp{
    width: 330px;
    box-sizing: border-box;
    position: relative;

    .slt-tar{
      position: relative;
      height: 56px;
      /*padding-left: 10px;*/
      background: #fff;
      box-sizing: border-box;
      border-radius: 4px;
      /*border: 1px solid #D6D7DC;*/
      cursor: pointer;
      display: flex;
      flex-direction: row;
      align-items: center;
      .icon-peoples{
        width: 68px;
        height: 28px;
        background: url("/static/images/components/icon_peoples.png") no-repeat center center;
      }
      .peoples-box{
        & > p:first-child{
          font-size: 18px;
          color: #323232;
        }
        /*& > p:last-child{*/
          /*font-size: 16px;*/
          /*color: #666666;*/
        /*}*/
      }
      span{
        color: #323232;
      }
      &:before{
        position: absolute;
        content: "";
        display: block;
        width: 54px;
        height: 100%;
        top: 0;
        right: 0;
        background: {
          repeat: no-repeat;
          size: 14px 8px;
          image: url("/static/images/components/down_open.png");
          position: center;
        };
      }
    }
    .oper-wrp{
      position: absolute;
      width: 232px;
      left: 50%;
      transform: translateX(-50%);
      top: 75px;
      padding: 20px;
      z-index: 5;
      background: #fff;
      border: 1px solid #E9E9E8;
      border-radius: 0 0 4px 4px;
      box-sizing: border-box;

      .person-ctrl{
        border-bottom: 1px dashed #C8C7CC;
      }
      .ctrl-row{
        height: 24px;
        line-height: 24px;
        margin-bottom: 20px;
        font-size: 18px;
        .ct-left{
          float: left;
          color: #666;
        }
        .ct-right{
          float: right;
          text-align: right;
        }
      }

      .bottom-ctrl{
        .child-tt{
          margin-top: 20px;
          margin-bottom: 10px;
          font-size: 18px;
        }
        .bt-row{
          margin-top: 20px;
          font-size: 0;
          button{
            width: 100%;
            height: 40px;
            line-height: 40px;
            text-align: center;
            font-size: 18px;
            color: #fff;
            border-radius: 4px;
            background-color: #088DE8;
            &:hover{
              background-color: #08a6e8;
              cursor: pointer;
            }
          }
        }
        .cancel-btn{
          margin-right: 20px;
        }
      }
      &:before, &:after {
        position: absolute;
        display: inline-block;
        border-bottom-color: rgba(0, 0, 0, 0.2);
        content: '';
      }
      &:after {
        top: -9px;
        border-right: 9px solid transparent;
        border-bottom: 9px solid #fff;
        border-left: 9px solid transparent;
        left: 50%;
      }
      &.opensright:after {
        left: 50%;
        transform: translateX(-50%);
      }
      &.opensright:before {
        left: 50%;
        transform: translateX(-50%);
      }
      &:before {
        top: -10px;
        left: 50%;
        transform: translateX(-1px);
        border-right: 10px solid transparent;
        border-left: 10px solid transparent;
        border-bottom: 10px solid #ccc;
      }
    }
  }

  .bg-mask{
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 1;
    background: transparent;
  }
</style>



// WEBPACK FOOTER //
// src/components/CheckInRoomNumber/index.vue